function m(r, o) {
  var t = {};
  for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && o.indexOf(e) < 0 && (t[e] = r[e]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, e = Object.getOwnPropertySymbols(r); n < e.length; n++)
      o.indexOf(e[n]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[n]) && (t[e[n]] = r[e[n]]);
  return t;
}
function v(r, o, t, e, n, s) {
  function c(l) {
    if (l !== void 0 && typeof l != "function") throw new TypeError("Function expected");
    return l;
  }
  for (var p = e.kind, w = p === "getter" ? "get" : p === "setter" ? "set" : "value", f = !o && r ? e.static ? r : r.prototype : null, a = o || (f ? Object.getOwnPropertyDescriptor(f, e.name) : {}), i, b = !1, h = t.length - 1; h >= 0; h--) {
    var y = {};
    for (var d in e) y[d] = d === "access" ? {} : e[d];
    for (var d in e.access) y.access[d] = e.access[d];
    y.addInitializer = function(l) {
      if (b) throw new TypeError("Cannot add initializers after decoration has completed");
      s.push(c(l || null));
    };
    var u = (0, t[h])(p === "accessor" ? { get: a.get, set: a.set } : a[w], y);
    if (p === "accessor") {
      if (u === void 0) continue;
      if (u === null || typeof u != "object") throw new TypeError("Object expected");
      (i = c(u.get)) && (a.get = i), (i = c(u.set)) && (a.set = i), (i = c(u.init)) && n.unshift(i);
    } else (i = c(u)) && (p === "field" ? n.unshift(i) : a[w] = i);
  }
  f && Object.defineProperty(f, e.name, a), b = !0;
}
function _(r, o, t) {
  for (var e = arguments.length > 2, n = 0; n < o.length; n++)
    t = e ? o[n].call(r, t) : o[n].call(r);
  return e ? t : void 0;
}
function g(r, o, t, e) {
  function n(s) {
    return s instanceof t ? s : new t(function(c) {
      c(s);
    });
  }
  return new (t || (t = Promise))(function(s, c) {
    function p(a) {
      try {
        f(e.next(a));
      } catch (i) {
        c(i);
      }
    }
    function w(a) {
      try {
        f(e.throw(a));
      } catch (i) {
        c(i);
      }
    }
    function f(a) {
      a.done ? s(a.value) : n(a.value).then(p, w);
    }
    f((e = e.apply(r, o || [])).next());
  });
}
function E(r, o, t, e) {
  if (t === "a" && !e) throw new TypeError("Private accessor was defined without a getter");
  if (typeof o == "function" ? r !== o || !e : !o.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? e : t === "a" ? e.call(r) : e ? e.value : o.get(r);
}
function O(r, o, t, e, n) {
  if (e === "m") throw new TypeError("Private method is not writable");
  if (e === "a" && !n) throw new TypeError("Private accessor was defined without a setter");
  if (typeof o == "function" ? r !== o || !n : !o.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e === "a" ? n.call(r, t) : n ? n.value = t : o.set(r, t), t;
}
export {
  E as _,
  O as a,
  _ as b,
  v as c,
  g as d,
  m as e
};
